export const HIERARCHY_SEPARATOR = '__';

export const getDeepestHierarchyLevel = (path: string): string => {
  return path.split(HIERARCHY_SEPARATOR).at(-1) ?? path;
};
